import { LoginLojistas } from "./loginLojistas";

if (typeof _pagination == "undefined" || _pagination.pages.length <= 0) {
  // console.info('a variável _pagination não foi setada ou não há paginação');
  window._pagination = false;
}

window.lojistaCart = {
  items: [],
  clientInfos: [],
  getProductById: function (_productId) {
    return this.items.filter(function (el, i) {
      return el.id == _productId;
    });
  },
  removeProduct: function (_productId) {
    var product = this.getProductById(_productId);

    // console.info('excluindo produto', product);

    if (product.length > 1) {
      for (var i = 0; i < product.length; i++) {
        this.items.splice(product[i].indice, 1);
      }
    } else {
      this.items.splice(product[0].indice, 1);
    }
  },
  saveLocal: function () {
    // console.log('saveLocal')
    localStorage.lojistaCart = JSON.stringify(this.items);
  },
  saveProduct: function (_product) {
    _product["indice"] = this.items.length;
    this.items.push(_product);
  },
  saveClientInfosLocal: function () {
    localStorage.clientInfos = JSON.stringify(this.clientInfos);
  },
  saveClientInfos: function (_$form) {
    //Transforma array de serializeArray em um objeto
    function objectifyForm(formArray) {
      var returnArray = {};
      for (var i = 0; i < formArray.length; i++) {
        returnArray[formArray[i]["name"]] = formArray[i]["value"];
      }
      return returnArray;
    }

    var infos = _$form.serializeArray();
    this.clientInfos = objectifyForm(infos);
  },
  updateProduct: function (_obj) {
    var product = this.getProductById(_obj.id);

    // console.info('updateProduct', product, _obj);

    if (product.length == 0) {
      // console.info('não tem produto');
      if (_obj.variants.length > 0) {
        this.saveProduct(_obj);
      }
    } else {
      // console.info('tem produto', );
      if (_obj.variants.length > 0) {
        // console.info('1');
        _obj["indice"] = product[0].indice;
        this.items[product[0].indice] = _obj;
      } else {
        // console.info('2');
        this.removeProduct(_obj.id);
      }
    }

    this.saveLocal();
    this.buildCart();

    // console.info('this.items', this.items);
  },
  setCartWithoutProducts: function () {
    var $wrapperCart = $("[data-wrapper-cart-products]");
    var html = "";

    html =
      "" +
      '<div class="without-products">' +
      "<p>Nenhum produto adicionado</p>" +
      "</div>";

    $wrapperCart.html(html);

    this.updateValorTotalOrder();
  },
  fetchProducts: function () {
    if (
      typeof localStorage.lojistaCart != "undefined" &&
      $("[data-item-cart]").length > 0
    ) {
      var storedProducts = JSON.parse(localStorage.lojistaCart);

      for (var i = 0; i < storedProducts.length; i++) {
        storedProducts[i].indice = i;
      }
      this.items = storedProducts;
    } else {
      localStorage.lojistaCart = "";
      this.items = [];
    }
  },
  fetchClientInfos: function () {
    if (typeof localStorage.clientInfos != "undefined") {
      this.clientInfos = JSON.parse(localStorage.clientInfos);
    }
  },
  getValorTotalProduct: function (_product) {
    var valorTotal = 0;
    var quantity = 0;

    for (var i = 0; i < _product.variants.length; i++) {
      quantity += _product.variants[i].quantity;
    }

    return quantity * _product.price;
  },
  getValorTotalOrder: function () {
    var valorTotal = 0;

    for (var i = 0; i < this.items.length; i++) {
      var valorProduto = this.getValorTotalProduct(this.items[i]);

      valorTotal += valorProduto;
    }

    return valorTotal;
  },
  buildCart: function () {
    var $wrapperCart = $("[data-wrapper-cart-products]");
    var htmlItems = "";

    function buildVariants(_product) {
      var htmlVariants = "";

      for (var i = 0; i < _product.variants.length; i++) {
        var variant = _product.variants[i];
        htmlVariants +=
          "" +
          '<div class="size-item">' +
          "" +
          variant.label +
          "" +
          '<span class="qtd">(' +
          variant.quantity +
          ")</span>" +
          "</div>";
      }

      return htmlVariants;
    }

    for (var i = 0; i < this.items.length; i++) {
      var valorTotal = store.formatMoney(
        this.getValorTotalProduct(this.items[i])
      );
      htmlItems +=
        "" +
        '<div class="item" data-product-id="' +
        this.items[i].id +
        '" data-product-item>' +
        '<div class="product-image">' +
        '<img src="' +
        this.items[i].image +
        '">' +
        "</div>" +
        '<div class="infos-wrapper">' +
        '<h3 class="product-name">' +
        "" +
        this.items[i].name +
        "" +
        "</h3>" +
        '<p class="product-price">' +
        "" +
        store.formatMoney(this.items[i].price) +
        "" +
        "</p>" +
        '<div class="sizes">' +
        buildVariants(this.items[i]) +
        "</div>" +
        '<div class="total">Total: <span class="valor">' +
        valorTotal +
        "</span></div>" +
        "</div>" +
        "</div>";
    }

    this.updateValorTotalOrder();

    $wrapperCart.empty();
    $wrapperCart.html(htmlItems);
  },
  updateValorTotalOrder: function () {
    var valorTotal = this.getValorTotalOrder();

    $("[data-cart-valor-total]").html(store.formatMoney(valorTotal));
  },
  init: function () {
    this.fetchProducts();
    this.fetchClientInfos();

    if (this.items.length > 0) {
      this.buildCart();
    } else {
      this.setCartWithoutProducts();
    }
  },
};

window.lojistas_template = {
  login: {
    getClient: async function () {
      try {
        let response = await fetch(`/conta/cliente`, {
          headers: {
            accept: "application/json",
          },
        });
        let client = await response.json();

        if (Object.keys(client).length > 0) {
          return client;
        }
      } catch (error) {
        console.error(`getClient error`, error);
      }
    },
    setFormInformation: async function () {
      const formInformation = document.querySelector(
        ".logged-waiting #form_information"
      );

      if (formInformation) {
        let client = await window.lojistas_template.login.getClient();
        if (client) {
          let client_email = client.email;
          let client_fName = client.first_name;
          let client_lName = client.last_name;

          let clientEmailInput = formInformation.querySelector(
            "input[name='email']"
          );
          let clientUserInput = formInformation.querySelector(
            "input[name='usuario']"
          );
          let clientEmailField =
            formInformation.querySelector("#information-email");

          if (clientEmailInput) {
            clientEmailInput.value = client_email;
          }

          if (clientEmailField) {
            clientEmailField.innerHTML = client_email;
          }

          if (clientUserInput) {
            clientUserInput.value = `${client_fName} ${client_lName}`;
          }
        }
      }
    },
    validateLogin: function (_$form) {
      var validated = true;
      var errorsTxt = [];

      if (_$form.find('[name="email"]').val() == "") {
        validated = false;
        errorsTxt.push("Informe seu email!");
      }

      if (_$form.find('[name="password"]').val() == "") {
        validated = false;
        errorsTxt.push("Informe a senha!");
      }

      return { validated: validated, errors: errorsTxt };
    },
    validateRegister: function (_$form) {
      var validated = true;
      var errorsTxt = [];

      if (_$form.find('[name="email"]').val() == "") {
        validated = false;
        errorsTxt.push("Informe seu email!");
      }

      if (_$form.find('[name="password"]').val() == "") {
        validated = false;
        errorsTxt.push("Informe uma senha!");
      }

      if (_$form.find('[name="password"]').val() != "") {
        var pass = _$form.find('[name="password"]').val();
        var confirmationPass = _$form
          .find('[name="password_confirmation"]')
          .val();

        if (pass != confirmationPass) {
          validated = false;
          errorsTxt.push("Senha e confirmação são diferentes!");
        }
      }

      return { validated: validated, errors: errorsTxt };
    },
    validateRecover: function (_$form) {
      var validated = true;
      var errorsTxt = [];

      if (_$form.find('[name="email"]').val() == "") {
        validated = false;
        errorsTxt.push("Informe seu email!");
      }

      return { validated: validated, errors: errorsTxt };
    },
    logar: function (_$form) {
      var newClient = false;

      if (_$form.find('[name*="new_client"]').length > 0) {
        newClient = true;
      }

      console.log("newClient", newClient);

      if (!_$form.hasClass("sending")) {
        $.ajax({
          url: "/entrar",
          type: "POST",
          dataType: "json",
          data: _$form.serialize(),
          beforeSend: function () {
            _$form.addClass("sending");
          },
        })
          .done(function (resp) {
            console.log("success", resp);

            if (resp.error) {
              store.setMsgResponse(resp.error, "error", _$form);
            }

            if (resp.client) {
              console.info("novo cliente cadastrado", newClient);

              if (newClient) {
                var email = _$form.find('[name="email"]').val();
                _$form.removeClass("sending");
                let client = {};
                client["nome"] = $("#register-first-name").val();
                client["sobrenome"] = $("#register-last-name").val();
                client["email"] = $("#register-email").val();

                _$form.find('[name="password"]').remove();
                _$form.find('[name="password_confirmation"]').remove();

                // lojistas_template.login.sendClientToAirtable(client);

                store.submitForm(_$form, email, function () {});
                console.info("mandando form");
                if (location.search.indexOf("?") < 0) {
                  location.search = "?first-access";
                } else {
                  location.search = "&first-access";
                }
                location.reload();
              } else {
                window.location.href = resp.redirect_to;
                location.reload();
              }
            }
          })
          .fail(function (resp) {
            console.error("error", resp);
            // console.error("error", error.responseText);
          })
          .always(function () {
            // console.log("complete");
            _$form.removeClass("sending");
          });
      }
    },
    sendClientToAirtable: function (client) {
      $.ajax({
        type: "POST",
        url: "https://api.airtable.com/v0/appu9SG0UIPYn8RbP/Clientes?api_key=keyvd6spdHbHanaHb",
        dataType: "json",
        data: {
          fields: {
            Nome: client.nome,
            Sobrenome: client.sobrenome,
            Email: client.email,
          },
        },
      })
        .done(function (resp) {
          console.info("done", resp);
        })
        .fail(function () {
          console.info("error");
        });
    },
    recoverPassord: function (_$form) {
      if (!_$form.hasClass("sending")) {
        $.ajax({
          url: "/recuperar_senha",
          type: "POST",
          dataType: "json",
          data: _$form.serialize(),
          beforeSend: function () {
            _$form.addClass("sending");
          },
        })
          .done(function (resp) {
            // console.log("success", resp);

            if (resp.error) {
              store.setMsgResponse(resp.error, "error", _$form);
            }

            if (resp.ok) {
              store.setMsgResponse(resp.ok, "success", _$form);
            }

            /*if (resp.client) {
              window.location.href = resp.redirect_to;
            }*/
          })
          .fail(function (resp) {
            // console.error("error", error.responseText);
          })
          .always(function () {
            // console.log("complete");
            _$form.removeClass("sending");
          });
      }
    },
    cnpjMask: function(){
      const cnpjInput = document.getElementById('register-cnpj');

      cnpjInput.addEventListener('input', function () {
        let value = this.value.replace(/\D/g, ''); // Remove tudo que não for número

        // Aplica a máscara
        value = value
          .replace(/^(\d{2})(\d)/, '$1.$2')
          .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
          .replace(/\.(\d{3})(\d)/, '.$1/$2')
          .replace(/(\d{4})(\d)/, '$1-$2');

        this.value = value;
      });
    },
    init: function () {
      var _this = this;

      var $loginWrapper = $("[data-wrapper-login]");
      var $wrapperRegister = $("[data-wrapper-form-register]");
      var $wrapperLogin = $("[data-wrapper-form-login]");

      _this.setFormInformation();

      $loginWrapper.on("click", '[data-action="active-register"]', function () {
        $loginWrapper.removeClass("login-active");
        $loginWrapper.addClass("register-active");

        $wrapperLogin.removeClass("active");
        $wrapperRegister.addClass("active");
      });

      $loginWrapper.on("click", '[data-action="active-login"]', function () {
        $loginWrapper.removeClass("register-active");
        $loginWrapper.addClass("login-active");

        $wrapperRegister.removeClass("active");
        $wrapperLogin.addClass("active");
      });

      $("[data-content-login]").each(function (index, el) {
        // Animação

        $(el).on("click", "[data-forget-password]", function (event) {
          event.preventDefault();
          $(el).find("[data-form-login]").animate({ height: "toggle" }, 500);
          $(el).find("[data-form-recover]").animate({ height: "toggle" }, 500);
        });

        $(el).on("click", "[data-forget-password-back]", function (event) {
          event.preventDefault();
          $(el).find("[data-form-login]").animate({ height: "toggle" }, 500);
          $(el).find("[data-form-recover]").animate({ height: "toggle" }, 500);
        });

        $(el).on("submit", "[data-form-login]", function (event) {
          event.preventDefault();

          var $form = $(this);
          var respValidated = _this.validateLogin($form);

          if (respValidated.validated) {
            _this.logar($form);
          } else {
            store.setMsgResponse(respValidated.errors, "error", $(this));
          }
        });

        $(el).on("submit", "[data-form-register]", function (event) {
          event.preventDefault();

          var $form = $(this);
          var firstName = "";
          var lastName = "";
          //var nomeCompleto = $form.find('[name="nome_completo"]').val();
          var senha = $form.find('[name="password"]').val();

          // nomeCompleto = nomeCompleto.split(' ');
          // firstName = nomeCompleto.splice(0 ,1).toString();
          // lastName = nomeCompleto.join(' ');

          //console.info(firstName, lastName);

          // console.info($form.serializeArray());

          // console.info($form.find('[name="first_name"]').val());

          //$form.find('[name="first_name"]').val(firstName);
          //$form.find('[name="last_name"]').val(lastName);
          $form.find('[name="password_confirmation"]').val(senha);

          var respValidated = _this.validateRegister($form);

          // console.info(respValidated);

          if (respValidated.validated) {
            store.setMsgResponse(respValidated.errors, "clear", $(this));
            _this.logar($form);
          } else {
            store.setMsgResponse(respValidated.errors, "error", $(this));
          }
        });

        $(el).on("submit", "[data-form-recover]", function (event) {
          event.preventDefault();

          var $form = $(this);
          var respValidated = store.login.validateRecover($form);

          if (respValidated.validated) {
            store.login.recoverPassord($form);
          } else {
            store.setMsgResponse(respValidated.errors, "error", $(this));
          }
        });
      });

      _this.cnpjMask();

      //$('[data-mask="cnpj"]').mask('00.000.000/0000-00', { reverse: true });
    },
  },
  products: {
    infiniteProducts: {
      pagination: _pagination, // a variável _pagination é montada pelo liquid pegando as infos da paginação
      listsWrapper: $("[data-list-products-wrapper]"), // Elemento que engloba as páginas de produtos
      getCurrentPage: function () {
        // Retorna a página atual
        return this.pagination.currentPage;
      },
      getNextPage: function () {
        var _this = this;
        var currentPage = _this.getCurrentPage();
        var nextUrl = _this.pagination.nextUrl;

        // Verifica se já não há um ajax em andamento para não encadear vários requests
        if (!_this.listsWrapper.hasClass("searching")) {
          // Verifica se a página atual não é a última página
          if (currentPage >= _this.pagination.totalPages) {
            // console.info('não há mais páginas');
            _this.listsWrapper.addClass("no-more-products");
          } else {
            // Ajax que busca os produtos da página seguinte
            $.ajax({
              url: nextUrl,
              type: "GET",
              dataType: "html",
              xhrFields: { withCredentials: true },
              beforeSend: function () {
                _this.listsWrapper.addClass("searching");
              },
            })
              .done(function (_resp) {
                // Busca os produtos na página carregada por ajax
                var products = $(_resp).find(
                  ".list-products > .product-block-lojista"
                );

                // console.info('products', products);

                // Seta a página do ajax como atual
                _this.setCurrentPage(currentPage + 1);

                // Renderiza os produtos da página
                _this.renderMoreProducts(products);
              })
              .fail(function () {
                // console.log("error");
              })
              .always(function () {
                _this.listsWrapper.removeClass("searching");
              });
          }
        }
      },
      renderMoreProducts: function (_htmlProducts) {
        // Monta o html dos produtos da página carregada por ajax
        var _this = this;
        // var $listProducts = '<div class="list-products" data-page="' + _this.getCurrentPage() + '"></div>';
        var $listProducts = "";
        var $listProducts = $($listProducts);
        var st = $(window).scrollTop();

        // console.info(st);

        $listProducts.html(_htmlProducts);

        // console.info('_htmlProducts', _htmlProducts);

        _this.listsWrapper.find(".list-products").append(_htmlProducts);

        lojistas_template.products.setProductsAdded();
        _this.runProductsSobrando();
        lojistas_template.products.setImages();

        // Atualiza o preço dos novos produtos carregados
        const productsToUpdate = document.querySelectorAll(
          '.product-block-lojista[data-was-processed="false"]'
        );
        LoginLojistas.updateProductsPrice(productsToUpdate);

        setTimeout(function () {
          $(window).scrollTop(st);
        }, 5);
      },
      setCurrentPage: function (_number) {
        var current = this.getCurrentPage();
        var nextUrl = this.pagination.nextUrl;

        // Verifica se a página atual não é maior que o total de páginas
        if (_number <= this.pagination.totalPages) {
          // console.info('next url', nextUrl);

          // seta a página atual
          this.pagination.currentPage = _number;

          // Verifica se há próxima página
          if (_number < this.pagination.totalPages) {
            // Seta a url da próxima página
            nextUrl = this.pagination.pages[_number].url;
            this.pagination.nextUrl = nextUrl;
          }
        }
      },
      runProductsSobrando: function () {
        var _this = this;
        var productsInLine = 2;
        var listProducts = _this.listsWrapper.find(".product-block");
        var lengthProducts = listProducts.length;
        var mod;

        // Procura produtos que estão sobrando quando ainda há produtos para serem listados
        // Ex: 3 produtos em uma linha de 4

        if ($("body").width() > 768) {
          // 4 produtos por linha

          productsInLine = 3;

          if ($body.width() < 768) {
            productsInLine = 2;
          }
        } else {
          // 2 produtos por linha
        }

        mod = lengthProducts % productsInLine;

        // console.info('mod', mod);

        listProducts.removeClass("produto-sobrando");

        if (_this.pagination.currentPage < _this.pagination.totalPages) {
          if (mod > 0) {
            for (var i = 0; i < mod; i++) {
              // console.info(listProducts[(lengthProducts - 1) - i]);
              $(listProducts[lengthProducts - 1 - i]).addClass(
                "produto-sobrando"
              );
            }
          }
        }

        // console.info('productsInLine', productsInLine);
        // console.info('lengthProducts', lengthProducts);
      },
      init: function () {
        var _this = this;

        if (_this.pagination.totalPages > 1) {
          _this.runProductsSobrando();

          $(window).scroll(function (event) {
            var stTop = $(this).scrollTop();
            var stBottom = stTop + $(this).height();

            // Calcula o final da div de produtos para buscar mais produtos
            var listEnd =
              _this.listsWrapper.offset().top +
              _this.listsWrapper.outerHeight(true);

            if (stBottom >= listEnd) {
              // console.info('cheguei no final');
              _this.getNextPage();
            }
          });
        } else {
          _this.listsWrapper.addClass("no-more-products");
        }
      },
    },
    variants: {
      $attributes: $("[data-product-attributes]"),
      init: function () {
        var _this = this;

        $(document).on(
          "click",
          '[data-action="minus-quantity-size"]',
          function (event) {
            var $wrapper = $(this).closest("[data-wrapper-size]");
            var $inputSku = $wrapper.find("[data-product-size]");
            var $inputQtd = $wrapper.find("[data-input-quantity]");
            var stock = $inputSku.data("stock");
            var available = $inputSku.data("available");
            var valQtd = parseInt($inputQtd.val());

            if (available) {
              if (valQtd - 1 >= 0) {
                $inputQtd.val(valQtd - 1).trigger("change");
              } else {
                $inputQtd.val(0).trigger("change");
              }
            } else {
              $inputQtd.val(0).trigger("change");
            }
          }
        );

        $(document).on(
          "click",
          '[data-action="plus-quantity-size"]',
          function (event) {
            var $wrapper = $(this).closest("[data-wrapper-size]");
            var $inputSku = $wrapper.find("[data-product-size]");
            var $inputQtd = $wrapper.find("[data-input-quantity]");
            var stock = $inputSku.data("stock");
            var available = $inputSku.data("available");
            var valQtd = parseInt($inputQtd.val());

            if (available) {
              if (valQtd + 1 <= stock) {
                $inputQtd.val(valQtd + 1).trigger("change");
              } else {
                $inputQtd.val(valQtd).trigger("change");
              }
            } else {
              $inputQtd.val(0).trigger("change");
            }
          }
        );

        // $(document).on('change', '[data-input-quantity]', template_store.debounce(function (event) {
        //   let sku = $(this).closest('.size-wrapper').find('[data-product-size]').val();
        //   let quantity = $(this);
        //   var $product = $(this).closest('[data-product-block]');
        //   var $wrapper = $(this).closest('[data-wrapper-size]');
        //   var $inputSku = $wrapper.find('[data-product-size]');
        //   var valQtd = parseInt(quantity.val());

        //   $inputSku.data('quantity', valQtd);

        //   console.info('atualizando produto');
        //   lojistas_template.products.addProduct($product);

        //   console.log('alouuuu', sku, valQtd)

        //   lojistas_template.products.submitNewQuantity(valQtd, sku);
        // }, 1000));

        $(document).on(
          "click",
          '[data-action="update-product"]',
          function (event) {
            var comboItems = [];
            $(this)
              .closest("[data-product-block]")
              .find("[data-input-quantity]")
              .each(function (index, el) {
                let sku = $(el)
                  .closest(".size-wrapper")
                  .find("[data-product-size]")
                  .val();
                let quantity = $(el);
                var $product = $(el).closest("[data-product-block]");
                var $wrapper = $(el).closest("[data-wrapper-size]");
                var $inputSku = $wrapper.find("[data-product-size]");
                var valQtd = parseInt(quantity.val());

                $inputSku.data("quantity", valQtd);

                if (valQtd > 0) {
                  // console.info('atualizando produto');
                  lojistas_template.products.addProduct($product);

                  // console.log('alouuuu', sku, valQtd)

                  //lojistas_template.products.submitNewQuantity(valQtd, sku);

                  var item = {
                    sku: sku,
                    quantity: parseInt(valQtd, 10),
                  };

                  comboItems.push(item);
                }
              });
            var result = lojistas_template.products
              .addItemsCombo(comboItems)
              .then(function (response) {
                return response;
              }, Promise.resolve([]));

            result.then(function (results) {
              template_store.headerCart.loadCart(results);
            });
          }
        );
      },
    },
    submitNewQuantity: function (quantity, sku) {
      $.ajax({
        url: "/carrinho/adicionar",
        type: "POST",
        dataType: "json",
        data: {
          quantity: quantity,
          sku: sku,
        },
        xhrFields: { withCredentials: true },
      })
        .done(function (resp) {
          // console.log("success");
          // console.info(resp);
          //template_store.headerCart.loadCart(resp);

          var $boxCart = $("[data-cart-body]");

          store.updateCartCount(resp.items_count);

          vnda.loadCartPopup(function (html) {
            $boxCart.empty();
            $boxCart.append(html);
          });
        })
        .fail(function (xhr, status, error) {
          // console.log("error");
          // console.error(xhr);
          // console.error(status);
          // console.error(error);
        })
        .always(function () {
          // console.log("complete");
        });
    },
    addProduct: function (_$product) {
      // console.log('addProduct', _$product)

      var productId = _$product.data("product-id");
      var productReference = _$product.data("product-reference");
      var productName = _$product
        .find("[data-product-name]")
        .data("product-name");
      var productPrice = _$product
        .find("[data-product-price]")
        .data("product-price");
      var productImage = _$product
        .find("[data-product-image]")
        .data("product-image");
      var variantsAdded = [];

      _$product
        .find('[data-product-size][data-available="true"]')
        .each(function (index, el) {
          if ($(el).data("quantity") > 0) {
            variantsAdded.push({
              sku: String($(el).val()),
              quantity: $(el).data("quantity"),
              label: String($(el).data("variant-label")),
            });
          }
        });

      // console.log('variantsAdded', variantsAdded)

      lojistaCart.updateProduct({
        reference: String(productReference),
        id: productId,
        variants: variantsAdded,
        name: productName,
        price: parseFloat(productPrice),
        image: productImage,
      });
    },
    updateProductAdded: function (_$product, _product) {
      var $attributes = _$product.find("[data-product-attributes]");

      for (var i = 0; i < _product.variants.length; i++) {
        var $input = $attributes.find(
          '[data-product-size][value="' + _product.variants[i].sku + '"]'
        );
        var $variant = $input.closest("[data-wrapper-size]");

        $input.data("quantity", _product.variants[i].quantity);
        $variant.addClass("size-added");
        $variant
          .find("[data-input-quantity]")
          .val(_product.variants[i].quantity);
      }
    },
    setProductsAdded: function () {
      var _this = this;
      var $wrapperProducts = $("[data-list-products-wrapper] .list-products");
      var $products = $wrapperProducts.find("[data-product-block]");

      $products.each(function (index, el) {
        var productId = $(el).data("product-id");
        var product = lojistaCart.getProductById(productId);

        if (product.length > 0) {
          _this.updateProductAdded($(el), product[0]);
        }
      });
    },
    toggleProductsWrapper: function () {
      var _this = this;
      var $wrapperProducts = $("[data-box-cart-products]");
      var heightContent = $wrapperProducts
        .find("[data-wrapper-cart-products]")
        .outerHeight(true);

      if ($wrapperProducts.hasClass("active")) {
        // $wrapperProducts.css('height', '0px');
        $wrapperProducts.removeClass("active");
      } else {
        // $wrapperProducts.css('height', heightContent + 'px');
        $wrapperProducts.addClass("active");
      }
    },
    focusProductBlock: function (_productId) {
      var $productBlock = $(
        '[data-product-block][data-product-id="' + _productId + '"]'
      );
      var top = $productBlock.offset().top;

      this.toggleProductsWrapper();

      setTimeout(function () {
        $("html, body").animate(
          {
            scrollTop: top - 250,
          },
          "250"
        );

        $productBlock.addClass("focus");

        setTimeout(function () {
          $productBlock.removeClass("focus");
        }, 1500);
      }, 350);
    },
    setImages: function () {
      var $productBlock = $("[data-product-block]");

      $productBlock.each(function (i, el) {
        var $img = $(el).find("[data-product-image]");

        if (typeof $img.data("image-seted") == "undefined") {
          var src = $img.data("src");
          $img.attr("src", src);
          $img.data("image-seted", true);
        }
      });
    },
    addItemsCombo: function (comboItems) {
      var data = {
        items: comboItems,
      };

      var form_data = JSON.stringify(data);

      return $.ajax({
        url: "/carrinho/adicionar/kit",
        type: "POST",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        xhrFields: {
          withCredentials: true,
        },
        cache: false,
        data: form_data,
      });
    },
    init: function () {
      var _this = this;

      this.variants.init();
      this.infiniteProducts.init();

      lojistaCart.init();

      $(document).on(
        "click",
        '[data-action="update-product"]',
        function (event) {
          event.preventDefault();

          var $product = $(this).closest("[data-product-block]");

          // console.info('atualizando produto');
          _this.addProduct($product);
        }
      );

      $(document).on("click", '[data-action="open-cart"]', function (event) {
        _this.toggleProductsWrapper();
      });

      $(document).on(
        "click",
        '[data-action="concluir-pedido"]',
        function (event) {
          lojistas_template.popupFinish.togglePopup("finish-order");
        }
      );

      $(document).on(
        "click",
        "[data-wrapper-cart-products] [data-product-item]",
        function () {
          var productId = $(this).data("product-id");

          _this.focusProductBlock(productId);
        }
      );

      this.setProductsAdded();
      this.setImages();
    },
  },
  init: function () {
    var _this = this;

    _this.login.init();
    _this.products.init();
  },
};

lojistas_template.init();
